var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveRecordIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.50016 0.5H22.5002C23.1445 0.5 23.6668 1.02234 23.6668 1.66667V20.3333C23.6668 20.9777 23.1445 21.5 22.5002 21.5H1.50016C0.855836 21.5 0.333496 20.9777 0.333496 20.3333V1.66667C0.333496 1.02234 0.855836 0.5 1.50016 0.5ZM10.9805 11H2.66683V19.1667H21.3335V11H20.0198C19.5017 13.0127 17.6746 14.5 15.5002 14.5C13.3257 14.5 11.4986 13.0127 10.9805 11ZM10.9805 8.66667C11.4986 6.6539 13.3257 5.16667 15.5002 5.16667C17.6746 5.16667 19.5017 6.6539 20.0198 8.66667H21.3335V2.83333H2.66683V8.66667H10.9805ZM15.5002 12.1667C16.7889 12.1667 17.8335 11.122 17.8335 9.83333C17.8335 8.54467 16.7889 7.5 15.5002 7.5C14.2115 7.5 13.1668 8.54467 13.1668 9.83333C13.1668 11.122 14.2115 12.1667 15.5002 12.1667ZM5.00016 14.5H7.3335V16.8333H5.00016V14.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveRecordIcon);
export default __webpack_public_path__ + "static/media/activeRecordIcon.aae49f66fab4cc63ca763954706786ac.svg";
export { ForwardRef as ReactComponent };